import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { perseusChargerRepositoryBuilder } from './PerseusChargerRepository'

export const perseusChargerRepository = () => perseusChargerRepositoryBuilder({
  httpService: new AxiosHttpServiceBuilder()
})
